import { Component, computed, inject, OnInit } from '@angular/core';
import { ClientsService } from '../../clientes/services/clients.service';
import { UsersService } from '../../usuarios/services/users.service';
import { ThemeService } from '@/app/core/services/theme/theme.service';

@Component({
  selector: 'app-inicio-component',
  standalone: true,
  imports: [],
  templateUrl: './inicio-component.html',
  styleUrl: './inicio-component.scss',
})
export class InicioComponent implements OnInit {
  private themeService = inject(ThemeService);
  private clientsService = inject(ClientsService);
  private usersService = inject(UsersService);

  protected themeContent = this.themeService.themeContent;
  protected welcomeComponent = computed(() => this.themeContent()?.welcome);


  ngOnInit(): void {
    // Preload clients and users data
    this.clientsService.getAllClients().subscribe();
    this.usersService.getUsers().subscribe();
  }
}
